import * as Sentry from '@sentry/react';
import { AxiosError, AxiosInstance } from 'axios';

export function setupSentryInterceptor(axios: AxiosInstance) {
  axios.interceptors.response.use(
    (resp) => resp,
    (err: AxiosError) => {
      const url = err.response?.config.url ?? 'Unknown';
      const statusCode = err.response?.status ?? 0;

      if (statusCode >= 500 || statusCode === 404 || statusCode === 400) {
        Sentry.withScope((scope) => {
          if (err.config?.headers) {
            scope.setTags({
              status: statusCode,
              requestId: err.config.headers['X-Request-Id'] || '',
              sessionId: err.config.headers['X-Session-Id'] || '',
            });
          }

          const error = new Error();
          error.name = `API Error (${statusCode}) - ${url}`;
          Sentry.captureException(error);
        });
      }

      return Promise.reject(err);
    }
  );
}
